export default url => new Promise(resolve => {
  const img = new Image()
  img.crossOrigin = 'Anonymous'
  img.src = url
  img.onerror = () => resolve(url)
  img.onload = () => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.height = img.height
    canvas.width = img.width
    ctx.drawImage(img, 0, 0)
    resolve(canvas.toDataURL())
  }
})
